import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, Coffee, Repeat, ShoppingCart, Calendar } from 'lucide-react';
export function WhatYouGet() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const items = [{
    icon: <BookOpen data-id="element-203" />,
    text: 'El Sistema 3 Palancas explicado sin tecnicismos'
  }, {
    icon: <Coffee data-id="element-204" />,
    text: 'Guías para tacos, antojitos y comida de calle'
  }, {
    icon: <Check data-id="element-205" />,
    text: "Desayunos, comidas y cenas mexicanas 'antipico'"
  }, {
    icon: <Repeat data-id="element-206" />,
    text: 'Swaps que se sienten como comida (no castigo)'
  }, {
    icon: <Calendar data-id="element-207" />,
    text: 'Menú ejemplo de 7 días para repetir 4 semanas'
  }, {
    icon: <ShoppingCart data-id="element-208" />,
    text: 'Lista de súper base México'
  }, {
    icon: <Check data-id="element-209" />,
    text: 'Tracker imprimible 30 días para que veas progreso'
  }];
  return <section className="py-16 px-4 md:py-24 bg-white" data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <div className="text-center mb-12" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-213">
            Lo que recibes (sin relleno)
          </h2>
          <p className="text-xl text-gray-600" data-id="element-214">
            El Plato Mexicano Antipicos (30 días) incluye:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-215">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-green-200 transition-colors" data-id="element-216">
              <div className="bg-green-100 p-2 rounded-lg text-[#2F855A] mr-4 flex-shrink-0" data-id="element-217">
                {item.icon}
              </div>
              <span className="text-gray-800 font-medium text-lg self-center" data-id="element-218">
                {item.text}
              </span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-219">
          <button onClick={scrollToPricing} className="inline-flex items-center justify-center px-8 py-3 text-base font-bold text-[#2F855A] bg-green-50 rounded-full hover:bg-green-100 transition-colors border-2 border-[#2F855A]" data-id="element-220">
            Obtén tu plan ahora
          </button>
        </div>
      </div>
    </section>;
}